import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getPost } from "./slice";
import PostContent from "./post-content";
import PostInfo from "./post-info";
import { Col, Row, Skeleton } from "antd";
import {
  ColumnCenterContainer,
  MarginContainer,
  PostFooter,
} from "../common/components";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import TableOfContents from "./table-of-contents";
import { Helmet } from "react-helmet-async";
import { HalfHeader } from "../common/header";

const Post = () => {
  const { id } = useParams();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPost = async () => {
      setLoading(true);
      const data = (await getPost(id)).data.content;
      setPost(data);
      setLoading(false);
    };
    loadPost();
  }, [id]);

  return (
    <>
      <Helmet>
        <title>{post?.title}</title>
      </Helmet>
      <HalfHeader />
      <MarginContainer>
        {loading ? (
          <ColumnCenterContainer>
            <Skeleton
              css={css`
                width: 80%;
              `}
              active
            />
          </ColumnCenterContainer>
        ) : (
          <Row>
            <Col span={2} />
            <Col span={16}>
              <PostContent post={post} />
            </Col>
            <Col span={1} />
            <Col span={3}>
              <PostInfo post={post} />
              <MarginContainer />
              <TableOfContents />
            </Col>
          </Row>
        )}
      </MarginContainer>
      {!loading && <PostFooter />}
    </>
  );
};

export default Post;
